import { useContext, useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { AppContext } from "../Base";

// v1 URL structure will be: http://icare.sgfin.tech/#/site?version=[version]
const VALID_VERS = ['sgfin', 'mscsgf', 'shared'];
export default function ScanLandingPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [siteversion, setSiteVersion] = useContext(AppContext).siteversionState;

    useEffect(() => {
        var paramSiteversion = searchParams.get('version');
        if (!VALID_VERS.includes(paramSiteversion)) {
            paramSiteversion = 'shared';
        }
        setSiteVersion(paramSiteversion)
        document.cookie = `icare_siteversion=${paramSiteversion}; Secure`;
    }, [searchParams])
    return <Navigate to="/new-user" />
}